var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"site-mobile-nav",class:{ 'is-active': _vm.state.mobileNavActive },attrs:{"style-max-size":"medium"}},[_c('div',{staticClass:"inner"},[_c('ul',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }